import { inLang, formatLang, getNavigatorLang } from "../utils";
import { DEFAULT_LOCAL_KEY, DEFAULT_COOKIE_KEY, DEFAULT_SEARCH_KEY, PANDA_DEBUG_SEARCH_KEY, PANDA_I18N_PACK } from "../const";
import { pandaSelf } from "../const/globalThis";

// 确保新老的基础参数都能被覆盖，保留对象引用关系
if (typeof window.__PANDA !== 'object') {
  window.__PANDA = {
    cookieKey: DEFAULT_COOKIE_KEY,
    lang: getNavigatorLang(),
    logLevel: 2
  };
}
window.__PANDA.cookieKey = window.__PANDA.cookieKey || DEFAULT_COOKIE_KEY;
window.__PANDA.lang = window.__PANDA.lang || getNavigatorLang();
window.__PANDA.logLevel = window.__PANDA.hasOwnProperty('logLevel') ? window.__PANDA.logLevel : 2;
window[PANDA_I18N_PACK] = window[PANDA_I18N_PACK] || {};

// searchlang和debug的标记位
if (typeof location !== 'undefined' && location.search) {
  var urlParams = new URLSearchParams(location.search);
  var searchLang = urlParams.get(DEFAULT_SEARCH_KEY);
  if (searchLang) {
    var formatedLang = formatLang(searchLang);
    if (inLang(formatedLang)) {
      window.__PANDA.searchLang = formatedLang;
    }
  }
  if (urlParams.get(PANDA_DEBUG_SEARCH_KEY)) {
    pandaSelf.debug = true;
  }
}

// localLang的标记位
if (typeof localStorage !== 'undefined') {
  var lang = localStorage.getItem(DEFAULT_LOCAL_KEY);
  if (lang) {
    window.__PANDA.localLang = lang;
  }
}